import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { PlateProvider } from '@udecode/plate';

import { StyledOverflow } from 'components/common/dynamic_overflow';
import { useExecuteAction } from 'components/hooks/connect_hooks';
import FormatterContext from 'components/composer/shared/formatter_context';
import ToggleTaskFormattingVisible from 'actions/task/toggle_task_formatting_visible';
import connect from 'components/lib/connect';

export function EditorWrapper(props) {
  const { children, 'data-aid': dataaid, className, editor, id, isFormattingVisible, notSticky, innerRef: ref } = props;

  const executeAction = useExecuteAction();
  const toggleIsFormattingVisible = useCallback(() => {
    executeAction(ToggleTaskFormattingVisible);
  }, []);

  const value = useMemo(() => {
    return { isFormattingVisible, toggleIsFormattingVisible };
  }, [isFormattingVisible, toggleIsFormattingVisible]);

  return (
    <PlateProvider editor={editor} id={id}>
      <FormatterContext.Provider value={value}>
        <StyledEditorWrapper $notSticky={notSticky} className={className} data-aid={dataaid} ref={ref}>
          {children}
        </StyledEditorWrapper>
      </FormatterContext.Provider>
    </PlateProvider>
  );
}

EditorWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  'data-aid': PropTypes.string,
  editor: PropTypes.object,
  id: PropTypes.string,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  isFormattingVisible: PropTypes.bool,
  notSticky: PropTypes.bool,
};

const EditorWrapperContainer = connect(mapStateToProps)(EditorWrapper);

function mapStateToProps({ getProvider }) {
  return {
    isFormattingVisible: getProvider('agentLocalState').get().isTaskCommentFormattingOpen,
  };
}

export default EditorWrapperContainer;

const StyledEditorWrapper = styled.div`
  background-color: ${p => p.theme.colors.white};
  border-top: 1px solid ${p => p.theme.colors.gray200};
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  margin-left: 16px;
  margin-right: 16px;
  padding-bottom: 8px;
  padding-top: 8px;
  ${p => (p.$notSticky ? '' : 'bottom: 0; position: sticky;')}

  textarea {
    border: 1px solid ${p => p.theme.colors.gray400};
    border-radius: ${p => p.theme.borderRadius.default};
    margin-left: ${p => p.theme.spacing.medium};
    outline: none;
    padding: 8px 12px;
    resize: none;
    width: 100%;
    &:focus {
      border-color: ${p => p.theme.colors.green400};
    }
  }

  ${StyledOverflow} {
    justify-content: flex-start;
    margin-bottom: 8px;
  }
`;
